import Popup from '../../utils/popup';
import Tools from "../../utils/tools";
class DaneDoFaktur {
    constructor() {
        this.labelRadiobox = '.js-label-radiobox';
    }

    events() {
        const _this = this;
        $(document).on('click', this.labelRadiobox, function() {
            let inputValue = $(this)
                .find('input')
                .val();

            _this.collapseTarget(inputValue);
        });

        $('#dane_do_faktur-nip').on('focusout', function () {
            let nip = $(this).val();
            if (
                nip.length === 10 &&
                parseInt($('#dane_do_faktur-kraj').val()) === 1 //polska
            ) {
                _this.getGusData(nip);
            } else if(nip.length !== 10){
                let popup = new Popup(
                    translates.nip_zla_dlugosc
                );
                popup.showPopup();
            }
        });
    }


    collapseTarget(inputValue) {
        if (inputValue === '1') {
            $('#dane_do_faktur-imie, #dane_do_faktur-nazwisko')
                .removeAttr('disabled')
                .parents('.form__row')
                .removeClass('d-none');
            $('#dane_do_faktur-nazwa, #dane_do_faktur-nip')
                .attr('disabled', true)
                .parents('.form__row')
                .addClass('d-none');
        } else if (inputValue === '2') {
            $('#dane_do_faktur-nazwa, #dane_do_faktur-nip')
                .removeAttr('disabled')
                .parents('.form__row')
                .removeClass('d-none');
            $('#dane_do_faktur-imie, #dane_do_faktur-nazwisko')
                .attr('disabled', true)
                .parents('.form__row')
                .addClass('d-none');
        }
    }
    getGusData (nip) {
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            data: {
                json: true,
                ajax_action: "getGusData",
                nip: nip
            },
            success: function (result) {
                if (result && result.status === 'complete') {
                    let gusData = result.data;
                    $('#dane_do_faktur-nazwa').val(gusData.name);
                    $('#dane_do_faktur-ulica').val(gusData.street);
                    $('#dane_do_faktur-numer_budynku').val(gusData.building_number);
                    $('#dane_do_faktur-numer_lokalu').val(gusData.flat_number);

                    $('#dane_do_faktur-kod').val(gusData.postcode);
                    $('#dane_do_faktur-miejscowosc').val(gusData.city);
                } else {
                    if(result.message === 'Element do not exists') {
                        let popup = new Popup(
                            translates.nip_nie_znaleziono
                        );
                        popup.showPopup();
                    }
                }
            },
            error: function (xhr, status, error) {
                //
            }
        })

    }
    init() {
        this.events();
    }
}

export default DaneDoFaktur;
